<template>
  <div>
    <div v-if="driver || driver != null" class="md-layout">
      <v-toolbar
        :src="require('@/assets/images/vuebackground.jpg')"
        style="transform: translateY(0)"
      >
        <v-spacer></v-spacer>
        <v-menu :close-on-content-click="false" open-on-hover bottom offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              small
              v-on="on"
            >
              <span style="color:white">Options</span>
            </v-btn>
          </template>
    
          <v-list>
            <v-list-item @click="active = true">
              <v-list-item-title>History Status</v-list-item-title>
            </v-list-item>
            <v-list-group
              v-if="driver.driver_status != 3 &&
                    driver.driver_status != 4 &&
                    driver.driver_status != 5 &&
                    driver.driver_status != 8"
            >
              <template v-slot:activator>
                <v-list-item
                >
                  <v-list-item-title>Change Status</v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item
                v-if="driver.driver_status == 0 && role.requester"
                class="noprint"
                @click="updateStatusConfirmation(1, 'Request Approval')"
                ><v-list-item-title>Request Approval</v-list-item-title></v-list-item
              >
              <v-list-item
                v-if="driver.driver_status == 1 && role.approver"
                class="noprint"
                @click="updateStatusConfirmation(3, 'Approve')"
                ><v-list-item-title>Approve</v-list-item-title></v-list-item
              >
              <v-list-item
                v-if="driver.driver_status == 1 && role.approver"
                class="noprint"
                @click="updateStatusConfirmation(2, 'Reject')"
                ><v-list-item-title>Reject</v-list-item-title></v-list-item
              >
              <v-list-item
                v-if="driver.driver_status == 2 && role.requester"
                class="noprint"
                @click="updateStatusConfirmation(1, 'Request Approval')"
                ><v-list-item-title>Request Approval</v-list-item-title></v-list-item
              >
              <!-- <v-list-item v-if="driver.driver_status==6 && check_object_value(role_name,'name',['Admin','Revert Driver'])" class="noprint" @click="updateStatusConfirmation(4,'Revert to Waiting PKO')">Revert to Waiting PKO</v-list-item>
              <v-list-item v-if="driver.driver_status==7 && check_object_value(role_name,'name',['Admin','Revert Driver'])" class="noprint" @click="updateStatusConfirmation(3,'Revert to Waiting DP')">Revert to Waiting DP</v-list-item> -->

              <v-list-item
                v-if="driver.driver_status == 6 && role.requester"
                class="noprint"
                @click="updateStatusConfirmation(4, 'Revert to Waiting PKO')"
                ><v-list-item-title>Revert to Waiting PKO</v-list-item-title></v-list-item
              >
              <v-list-item
                v-if="driver.driver_status == 7 && role.requester"
                class="noprint"
                @click="updateStatusConfirmation(3, 'Revert to Waiting DP')"
                ><v-list-item-title>Revert to Waiting DP</v-list-item-title></v-list-item
              >
            </v-list-group>
          </v-list>
        </v-menu>  
        <!-- <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              text
              small
              v-if="
                  driver.driver_status != 3 &&
                    driver.driver_status != 4 &&
                    driver.driver_status != 5 &&
                    driver.driver_status != 8
                "
            >
              <span style="color:white;">Change Status</span>
            </v-btn>
            <v-btn
              small
              text
              @click="active = true"
            >
              <span style="color:white;">History Status</span>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-if="driver.driver_status == 0 && role.requester"
              class="noprint"
              @click="updateStatusConfirmation(1, 'Request Approval')"
              >Request Approval</v-list-item
            >
            <v-list-item
              v-if="driver.driver_status == 1 && role.approver"
              class="noprint"
              @click="updateStatusConfirmation(3, 'Approve')"
              >Approve</v-list-item
            >
            <v-list-item
              v-if="driver.driver_status == 1 && role.approver"
              class="noprint"
              @click="updateStatusConfirmation(2, 'Reject')"
              >Reject</v-list-item
            >
            <v-list-item
              v-if="driver.driver_status == 2 && role.requester"
              class="noprint"
              @click="updateStatusConfirmation(1, 'Request Approval')"
              >Request Approval</v-list-item
            >
            <v-list-item
              v-if="driver.driver_status == 6 && role.requester"
              class="noprint"
              @click="updateStatusConfirmation(4, 'Revert to Waiting PKO')"
              >Revert to Waiting PKO</v-list-item
            >
            <v-list-item
              v-if="driver.driver_status == 7 && role.requester"
              class="noprint"
              @click="updateStatusConfirmation(3, 'Revert to Waiting DP')"
              >Revert to Waiting DP</v-list-item
            >
          </v-list>
        </v-menu> -->
        <v-btn icon @click="closeDetail()">
          <v-icon style="color:white;">mdi-export</v-icon>
        </v-btn>

        <template v-slot:extension>
            <v-toolbar-title style="color:white;">
              <p
                v-if="driver.driver_status == 0"
                style="text-align: left; font-weight:bold;"
              >
                REGISTERED
              </p>
              <p
                v-if="driver.driver_status == 1"
                style="text-align: left; font-weight:bold;"
              >
                WAITING APPROVAL
              </p>
              <p
                v-if="driver.driver_status == 2"
                style="text-align: left; font-weight:bold;"
              >
                REJECTED
              </p>
              <p
                v-if="driver.driver_status == 3"
                style="text-align: left; font-weight:bold;"
              >
                WAITING DP
              </p>
              <p
                v-if="driver.driver_status == 4"
                style="text-align: left; font-weight:bold;"
              >
                WAITING PKO
              </p>
              <p
                v-if="driver.driver_status == 5"
                style="text-align: left; font-weight:bold;"
              >
                ACTIVE
              </p>
              <p
                v-if="driver.driver_status == 6"
                style="text-align: left; font-weight:bold;"
              >
                PAYMENT COMPLETED
              </p>
              <p
                v-if="driver.driver_status == 7"
                style="text-align: left; font-weight:bold;"
              >
                TERMINATED BY PAYMENT
              </p>
              <p
                v-if="driver.driver_status == 8"
                style="text-align: left; font-weight:bold;"
              >
                ACTIVE OWNERSHIP
              </p>
            </v-toolbar-title>
        </template>
      </v-toolbar>

      <md-dialog
        class="z-index"
        :md-active.sync="active"
        
            >
        <md-dialog-title>
          History Status
          <md-button
            style="float:right;"
            class="md-dense md-round md-icon-button"
            @click="active = false"
          >
            <md-icon>close</md-icon>
          </md-button>
        </md-dialog-title>
        <md-card class="md-content1 md-scrollbar">
          <md-card-content>
            <md-table>
              <md-table-row>
                <md-table-head><b>Change</b></md-table-head>
                <md-table-head><b>By</b></md-table-head>
                <md-table-head><b>Action</b></md-table-head>
                <md-table-head><b>Status</b></md-table-head>
              </md-table-row>
              <md-table-row
                v-for="(item, index) in driver.driver_history_status"
                :key="index"
              >
                <md-table-cell>{{ $moment(item.updated_at).utc().format('DD-MM-YYYY HH:mm') }}</md-table-cell>
                <md-table-cell>{{ item.name_by }}</md-table-cell>
                <md-table-cell>
                  <span v-if="item.status_action == 1"
                    >Request Approval</span
                  >
                  <span v-if="item.status_action == 2">Approve</span>
                  <span v-if="item.status_action == 3">Reject</span>
                  <span v-if="item.status_action == 4">DP Paid</span>
                  <span v-if="item.status_action == 5"
                    >Driver Assigned</span
                  >
                  <span v-if="item.status_action == 6"
                    >Revert Waiting PKO</span
                  >
                  <span v-if="item.status_action == 7"
                    >Terminate By Payment</span
                  >
                  <span v-if="item.status_action == 8"
                    >Complete Payment</span
                  >
                  <span v-if="item.status_action == 9"
                    >Revert Waiting DP</span
                  >
                  <span v-if="item.status_action == 10"
                    >Change to Ownership</span
                  >
                </md-table-cell>
                <md-table-cell>
                  <span v-if="item.status == 0">Registered</span>
                  <span v-if="item.status == 1">Waiting Approval</span>
                  <span v-if="item.status == 2">Rejected</span>
                  <span v-if="item.status == 3">Waiting DP</span>
                  <span v-if="item.status == 4">Waiting PKO</span>
                  <span v-if="item.status == 5">Active</span>
                  <span v-if="item.status == 6">Payment Completed</span>
                  <span v-if="item.status == 7"
                    >Terminate by Payment</span
                  >
                  <span v-if="item.status == 8">Active Ownership</span>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
          <!-- <md-card-actions>
          </md-card-actions> -->
        </md-card>
      </md-dialog>


      <!-- <md-toolbar class="md-dense color" style="width:100%">
        <div style="width:50%">
          <h3 class="md-title" style="flex:1; margin-left:10px;">
            <p
              v-if="driver.driver_status == 0"
              style="text-align: left; font-weight:bold;"
            >
              REGISTERED
            </p>
            <p
              v-if="driver.driver_status == 1"
              style="text-align: left; font-weight:bold;"
            >
              WAITING APPROVAL
            </p>
            <p
              v-if="driver.driver_status == 2"
              style="text-align: left; font-weight:bold;"
            >
              REJECTED
            </p>
            <p
              v-if="driver.driver_status == 3"
              style="text-align: left; font-weight:bold;"
            >
              WAITING DP
            </p>
            <p
              v-if="driver.driver_status == 4"
              style="text-align: left; font-weight:bold;"
            >
              WAITING PKO
            </p>
            <p
              v-if="driver.driver_status == 5"
              style="text-align: left; font-weight:bold;"
            >
              ACTIVE
            </p>
            <p
              v-if="driver.driver_status == 6"
              style="text-align: left; font-weight:bold;"
            >
              PAYMENT COMPLETED
            </p>
            <p
              v-if="driver.driver_status == 7"
              style="text-align: left; font-weight:bold;"
            >
              TERMINATED BY PAYMENT
            </p>
            <p
              v-if="driver.driver_status == 8"
              style="text-align: left; font-weight:bold;"
            >
              ACTIVE OWNERSHIP
            </p>
          </h3>
        </div>
        <div style="width:50%; ">
          <div class="md-toolbar-section-end">
            <md-dialog
              class="z-index"
              :md-active.sync="active"
              v-bind:md-fullscreen="false"
            >
              <md-dialog-title>
                History Status
                <md-button
                  style="float:right;"
                  class="md-dense md-round md-icon-button"
                  @click="active = false"
                >
                  <md-icon>close</md-icon>
                </md-button>
              </md-dialog-title>
              <md-card class="md-content1 md-scrollbar">
                <md-card-content>
                  <md-table>
                    <md-table-row>
                      <md-table-head><b>Change</b></md-table-head>
                      <md-table-head><b>By</b></md-table-head>
                      <md-table-head><b>Action</b></md-table-head>
                      <md-table-head><b>Status</b></md-table-head>
                    </md-table-row>
                    <md-table-row
                      v-for="(item, index) in driver.driver_history_status"
                      :key="index"
                    >
                      <md-table-cell>{{ item.updated_at }}</md-table-cell>
                      <md-table-cell>{{ item.name_by }}</md-table-cell>
                      <md-table-cell>
                        <span v-if="item.status_action == 1"
                          >Request Approval</span
                        >
                        <span v-if="item.status_action == 2">Approve</span>
                        <span v-if="item.status_action == 3">Reject</span>
                        <span v-if="item.status_action == 4">DP Paid</span>
                        <span v-if="item.status_action == 5"
                          >Driver Assigned</span
                        >
                        <span v-if="item.status_action == 6"
                          >Revert Waiting PKO</span
                        >
                        <span v-if="item.status_action == 7"
                          >Terminate By Payment</span
                        >
                        <span v-if="item.status_action == 8"
                          >Complete Payment</span
                        >
                        <span v-if="item.status_action == 9"
                          >Revert Waiting DP</span
                        >
                        <span v-if="item.status_action == 10"
                          >Change to Ownership</span
                        >
                      </md-table-cell>
                      <md-table-cell>
                        <span v-if="item.status == 0">Registered</span>
                        <span v-if="item.status == 1">Waiting Approval</span>
                        <span v-if="item.status == 2">Rejected</span>
                        <span v-if="item.status == 3">Waiting DP</span>
                        <span v-if="item.status == 4">Waiting PKO</span>
                        <span v-if="item.status == 5">Active</span>
                        <span v-if="item.status == 6">Payment Completed</span>
                        <span v-if="item.status == 7"
                          >Terminate by Payment</span
                        >
                        <span v-if="item.status == 8">Active Ownership</span>
                      </md-table-cell>
                    </md-table-row>
                  </md-table>
                </md-card-content>
              </md-card>
            </md-dialog>

            <md-button class="nonprint; color md-dense" @click="active = true"
              >History Status</md-button
            >
            <md-menu md-direction="bottom-start">
              <md-button
                v-if="
                  driver.driver_status != 3 &&
                    driver.driver_status != 4 &&
                    driver.driver_status != 5 &&
                    driver.driver_status != 8
                "
                class="nonprint; color md-dense"
                md-menu-trigger
                >Change Status</md-button
              >
              <md-menu-content class="z-index">
                <md-menu-item
                  v-if="driver.driver_status == 0 && role.requester"
                  class="noprint"
                  @click="updateStatusConfirmation(1, 'Request Approval')"
                  >Request Approval</md-menu-item
                >
                <md-menu-item
                  v-if="driver.driver_status == 1 && role.approver"
                  class="noprint"
                  @click="updateStatusConfirmation(3, 'Approve')"
                  >Approve</md-menu-item
                >
                <md-menu-item
                  v-if="driver.driver_status == 1 && role.approver"
                  class="noprint"
                  @click="updateStatusConfirmation(2, 'Reject')"
                  >Reject</md-menu-item
                >
                <md-menu-item
                  v-if="driver.driver_status == 2 && role.requester"
                  class="noprint"
                  @click="updateStatusConfirmation(1, 'Request Approval')"
                  >Request Approval</md-menu-item
                >
                <md-menu-item
                  v-if="driver.driver_status == 6 && role.requester"
                  class="noprint"
                  @click="updateStatusConfirmation(4, 'Revert to Waiting PKO')"
                  >Revert to Waiting PKO</md-menu-item
                >
                <md-menu-item
                  v-if="driver.driver_status == 7 && role.requester"
                  class="noprint"
                  @click="updateStatusConfirmation(3, 'Revert to Waiting DP')"
                  >Revert to Waiting DP</md-menu-item
                >
              </md-menu-content>
            </md-menu>
            <md-button
              class="nonprint; color md-icon-button md-dense"
              @click="closeDetail()"
              ><md-icon>close</md-icon></md-button
            >
          </div>
        </div>
      </md-toolbar> -->
      <div class="md-layout-item md-size-100" style="margin-top:20px;">
        <viewer
          class="pointer "
          :src="driver.driver_photo"
          v-if="driver.driver_photo"
        >
          <img
            style="width: auto; max-height:400px; display: block; margin:auto;"
            :src="driver.driver_photo"
            alt="Photo Driver"
          />
          <!-- <img
            src="@/assets/images/avatar.jpg"
            class="photo img-fluid"
        /> -->
        </viewer>
      </div>
      <div
        class="md-layout-item md-size-100"
        style="margin:none !important; padding: none !important;"
      >
        <md-card>
          <!-- <md-card-header class="md-card-header-text md-card-header-blue">
                  <div class="card-text" >
                    <md-icon>person</md-icon>
                      <h4 class="title">Driver Info</h4>
                  </div>
              </md-card-header> -->
          <md-card-content>
            <md-table>
              <md-table-row>
                <md-table-cell
                  class="md-info"
                  style="text-align:left; font-weight:bold; width:120px;"
                  >Driver Name</md-table-cell
                >
                <md-table-cell
                  v-if="!driver.driver_name"
                  style="color:#aaa; width:150px;"
                  >No Data Available</md-table-cell
                >
                <md-table-cell v-else style="width:150px;">{{
                  driver.driver_name
                }}</md-table-cell>

                <md-table-cell
                  class="md-info"
                  style="text-align:left; font-weight:bold; width:150px;"
                  >Driver Gender</md-table-cell
                >
                <md-table-cell
                  v-if="driver.driver_gender == null"
                  style="color:#aaa; width:150px;"
                  >No Data Available</md-table-cell
                >
                <md-table-cell v-else style="width:150px;">
                  <span v-if="driver.driver_gender == 0">Pria</span>
                  <span v-if="driver.driver_gender == 1">Perempuan</span>
                </md-table-cell>
              </md-table-row>

              <md-table-row>
                <md-table-cell
                  class="md-info"
                  style="text-align:left; font-weight:bold; width:120px;"
                  >Nickname</md-table-cell
                >
                <md-table-cell
                  v-if="!driver.driver_nickname"
                  style="color:#aaa; width:150px;"
                  >No Data Available</md-table-cell
                >
                <md-table-cell v-else style="width:150px;">{{
                  driver.driver_nickname
                }}</md-table-cell>

                <md-table-cell
                  class="md-info"
                  style="text-align:left; font-weight:bold; width:150px;"
                  >Religion</md-table-cell
                >
                <md-table-cell
                  v-if="driver.driver_religion == null"
                  style="color:#aaa; width:150px;"
                  >No Data Available</md-table-cell
                >

                <md-table-cell v-else style="width:150px;">
                  <span v-if="driver.driver_religion == 1">Islam</span>
                  <span v-if="driver.driver_religion == 2">Kristen</span>
                  <span v-if="driver.driver_religion == 3">Katolik</span>
                  <span v-if="driver.driver_religion == 4">Budha</span>
                  <span v-if="driver.driver_religion == 5">Hindu</span>
                  <span v-if="driver.driver_religion == 6">Konghucu</span>
                  <span v-if="driver.driver_religion == 7">Lainnya</span>
                </md-table-cell>

                <!-- <md-table-cell class="md-info" style="text-align:left; font-weight:bold; width:150px;">Driver Type</md-table-cell> -->
                <!-- <md-table-cell v-if="driver.driver_type==null" style="color:#aaa; width:150px;">No Data Available</md-table-cell> -->
                <!-- <md-table-cell style="width:150px;">
                    <span v-if="driver.driver_type==0">BRAVO</span>
                    <span v-if="driver.driver_type==1">CHARLIE</span>
                </md-table-cell> -->
              </md-table-row>
              <md-table-row>
                <md-table-cell
                  class="md-info"
                  style="text-align:left; font-weight:bold; width:120px;"
                  >Driver Phone</md-table-cell
                >
                <md-table-cell
                  v-if="!driver.driver_phone_no"
                  style="color:#aaa; width:150px;"
                  >No Data Available</md-table-cell
                >
                <md-table-cell v-else style="width:150px;">{{
                  driver.driver_phone_no
                }}</md-table-cell>

                <md-table-cell
                  class="md-info"
                  style="text-align:left; font-weight:bold; width:150px;"
                  >Last Education</md-table-cell
                >
                <md-table-cell
                  v-if="driver.driver_last_education == null"
                  style="color:#aaa; width:150px;"
                  >No Data Available</md-table-cell
                >
                <md-table-cell v-else style="width:150px;">
                  <span v-if="driver.driver_last_education == 0">SD</span>
                  <span v-if="driver.driver_last_education == 1">SMP</span>
                  <span v-if="driver.driver_last_education == 2">SMA/SMK</span>
                  <span v-if="driver.driver_last_education == 3"
                    >Universitas</span
                  >
                  <span v-if="driver.driver_last_education == 4">Lainnya</span>
                </md-table-cell>
              </md-table-row>

              <md-table-row>
                <md-table-cell
                  class="md-info"
                  style="text-align:left; font-weight:bold; width:120px;"
                  >Driver Emergency Phone</md-table-cell
                >
                <md-table-cell
                  v-if="!driver.driver_emergency_phone_no"
                  style="color:#aaa; width:150px;"
                  >No Data Available</md-table-cell
                >
                <md-table-cell v-else style="width:150px;">{{
                  driver.driver_emergency_phone_no
                }}</md-table-cell>

                <md-table-cell
                  class="md-info"
                  style="text-align:left; font-weight:bold; width:150px;"
                  >Place of Birth</md-table-cell
                >
                <md-table-cell style="width:150px;"
                  ><span v-if="driver.driver_place_of_birth">{{
                    driver.driver_place_of_birth.city_name
                  }}</span></md-table-cell
                >
              </md-table-row>

              <md-table-row>
                <md-table-cell
                  class="md-info"
                  style="text-align:left; font-weight:bold; width:120px;"
                  >Driver Email</md-table-cell
                >
                <md-table-cell
                  v-if="!driver.driver_email"
                  style="color:#aaa; width:150px;"
                  >No Data Available</md-table-cell
                >
                <md-table-cell v-else style="width:150px;">{{
                  driver.driver_email
                }}</md-table-cell>

                <md-table-cell
                  class="md-info"
                  style="text-align:left; font-weight:bold; width:150px;"
                  >Date of Birth</md-table-cell
                >
                <md-table-cell
                  v-if="!driver.driver_date_of_birth"
                  style="color:#aaa; width:150px;"
                  >No Data Available</md-table-cell
                >
                <md-table-cell v-else style="width:150px;">{{
                  driver.driver_date_of_birth
                }}</md-table-cell>
              </md-table-row>

              <md-table-row>
                <md-table-cell
                  class="md-info"
                  style="text-align:left; font-weight:bold; width:120px;"
                  >VA Duitku</md-table-cell
                >
                <md-table-cell
                  v-if="driver.driver_va_no.duitku != null"
                  style="width:150px;"
                >
                  {{ driver.driver_va_no.duitku }}
                </md-table-cell>
                <md-table-cell v-else style="color:#aaa; width:150px;"
                  >No Data Available</md-table-cell
                >
                <md-table-cell
                  class="md-info"
                  style="text-align:left; font-weight:bold; width:120px;"
                  >Blood Type</md-table-cell
                >
                <md-table-cell
                  v-if="driver.driver_blood_type != null"
                  style="width:150px;"
                >
                  <span v-if="driver.driver_blood_type == 0">A</span>
                  <span v-if="driver.driver_blood_type == 1">B</span>
                  <span v-if="driver.driver_blood_type == 2">AB</span>
                  <span v-if="driver.driver_blood_type == 3">O</span>
                </md-table-cell>
                <md-table-cell v-else style="color:#aaa; width:150px;"
                  >No Data Available</md-table-cell
                >
              </md-table-row>

              <md-table-row>
                <md-table-cell
                  class="md-info"
                  style="text-align:left; font-weight:bold; width:120px;"
                  >VA BCA</md-table-cell
                >
                <md-table-cell
                  v-if="driver.driver_va_no.bca != null"
                  style="width:150px;"
                >
                  {{ driver.driver_va_no.bca }}
                </md-table-cell>
                <md-table-cell v-else style="color:#aaa; width:150px;"
                  >No Data Available</md-table-cell
                >
                <md-table-cell
                  class="md-info"
                  style="text-align:left; font-weight:bold; width:150px;"
                  >Pool</md-table-cell
                >
                <md-table-cell style="width:150px;">
                  <span v-if="driver.driver_pool != null">{{
                    driver.driver_pool.pool_name
                  }}</span>
                  <span v-else style="color:#aaaa"> - </span>
                </md-table-cell>
              </md-table-row>

              <md-table-row>
                <md-table-cell
                  class="md-info"
                  style="text-align:left; font-weight:bold; width:120px;"
                  >Registration Fee</md-table-cell
                >
                <md-table-cell v-if="driver.driver_dp" style="width:150px;"
                  >{{
                    driver.driver_dp.dp_type.dp_amount_name +
                      "-" +
                      formatPrice(driver.driver_dp.dp_type.dp_amount)
                  }}
                </md-table-cell>
                <md-table-cell v-else style="width:150px;"></md-table-cell>

                <md-table-cell
                  class="md-info"
                  style="text-align:left; font-weight:bold; width:150px;"
                  >Blacklist</md-table-cell
                >
                <md-table-cell style="width:150px;">
                  <span v-if="driver.driver_blacklist == 0">Yes</span>
                  <span v-if="driver.driver_blacklist == 1">No</span>
                </md-table-cell>
              </md-table-row>

              <md-table-row>
                <md-table-cell
                  class="md-info"
                  style="text-align:left; font-weight:bold; width:120px;"
                  >Address</md-table-cell
                >
                <md-table-cell
                  v-if="!driver.driver_address"
                  colspan="3"
                  style="color:#aaa;"
                  >No Data Available</md-table-cell
                >
                <md-table-cell v-else colspan="3">{{
                  driver.driver_address
                }}</md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>

      <!-- <div class="md-layout-item md-size-100">
        <tabs
          :tab-active="1"
          :tab-name="[
            'Document',
            'Registration Fee & PKO',
            'Penalty',
            'Payment History',
          ]"
          color-button="primary"
          plain
        >
          <template slot="tab-pane-1" class="justify-content">
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <h4 class="title">Identity</h4>
              </md-card-header>
              <md-card-content>
                <md-table>
                  <md-table-row style="background-color: azure;">
                    <md-table-head><b>Type</b></md-table-head>
                    <md-table-head><b>Identity No</b></md-table-head>
                    <md-table-head><b>Expire Date</b></md-table-head>
                    <md-table-head><b>Place of Issue</b></md-table-head>
                    <md-table-head><b>Address</b></md-table-head>
                    <md-table-head style="text-align:center;"
                      ><b>Photo</b></md-table-head
                    >
                  </md-table-row>
                  <md-table-row v-if="driver.driver_identity.length == 0">
                    <md-table-cell colspan="6" class="nodata"
                      >No Data Available</md-table-cell
                    >
                  </md-table-row>
                  <md-table-row
                    v-else
                    v-for="(item, index) in driver.driver_identity"
                    :key="index"
                  >
                    <md-table-cell>
                      <span v-if="item.driver_identity_type == 0">KTP</span>
                      <span v-if="item.driver_identity_type == 1">SKCK</span>
                      <span v-if="item.driver_identity_type == 2"
                        >Domisili</span
                      >
                      <span v-if="item.driver_identity_type == 3">KK</span>
                    </md-table-cell>
                    <md-table-cell>{{ item.driver_identity_no }}</md-table-cell>
                    <md-table-cell>{{
                      item.driver_identity_expire_date
                    }}</md-table-cell>
                    <md-table-cell>{{
                      item.driver_identity_place_of_issue
                    }}</md-table-cell>
                    <md-table-cell>{{
                      item.driver_identity_address
                    }}</md-table-cell>
                    <md-table-cell style="text-align:center;">
                      <span v-if="item.url_driver_identity_file"
                        ><a
                          v-if="item.url_driver_identity_file"
                          :href="item.url_driver_identity_file"
                          target="_blank"
                        >
                          View Photo</a
                        >
                      </span>
                      <span v-else class="nodata" style="text-align:center;"
                        >-</span
                      >
                    </md-table-cell>
                  </md-table-row>
                </md-table>
              </md-card-content>
            </md-card>

            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <h4 class="title">License</h4>
              </md-card-header>
              <md-card-content>
                <md-table>
                  <md-table-row style="background-color: azure;">
                    <md-table-head><b>license Type</b></md-table-head>
                    <md-table-head><b>license No</b></md-table-head>
                    <md-table-head><b>Expire Date</b></md-table-head>
                    <md-table-head><b>Address</b></md-table-head>
                    <md-table-head style="text-align:center;"
                      ><b>Photo</b></md-table-head
                    >
                  </md-table-row>
                  <md-table-row v-if="driver.driver_license.length == 0">
                    <md-table-cell colspan="6" class="nodata"
                      >No Data Available</md-table-cell
                    >
                  </md-table-row>
                  <md-table-row
                    v-else
                    v-for="(item, index) in driver.driver_license"
                    :key="index"
                  >
                    <md-table-cell>
                      <span v-if="item.driver_license_type == 0">A</span>
                      <span v-if="item.driver_license_type == 1">A Umum</span>
                      <span v-if="item.driver_license_type == 2">B</span>
                      <span v-if="item.driver_license_type == 3">B2</span>
                      <span v-if="item.driver_license_type == 4">B2 Umum</span>
                      <span v-if="item.driver_license_type == 5">C</span>
                      <span v-if="item.driver_license_type == 6">B1</span>
                      <span v-if="item.driver_license_type == 6">B1 Umum</span>
                    </md-table-cell>
                    <md-table-cell>{{ item.driver_license_no }}</md-table-cell>
                    <md-table-cell>{{
                      item.driver_license_expire_date
                    }}</md-table-cell>
                    <md-table-cell>{{
                      item.driver_license_address
                    }}</md-table-cell>
                    <md-table-cell style="text-align:center;">
                      <span v-if="item.url_driver_license_file"
                        ><a
                          v-if="item.url_driver_license_file"
                          :href="item.url_driver_license_file"
                          target="_blank"
                        >
                          View Photo</a
                        >
                      </span>
                      <span v-else class="nodata" style="text-align:center;"
                        >-</span
                      >
                    </md-table-cell>
                  </md-table-row>
                </md-table>
              </md-card-content>
            </md-card>

            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <h4 class="title">Bank Account</h4>
              </md-card-header>
              <md-card-content>
                <md-table>
                  <md-table-row style="background-color:azure">
                    <md-table-head><b>Bank Name</b></md-table-head>
                    <md-table-head><b>Account No</b></md-table-head>
                    <md-table-head><b>Bank Account Holder</b></md-table-head>
                  </md-table-row>
                  <md-table-row v-if="driver.driver_bank_account.length == 0">
                    <md-table-cell colspan="6" class="nodata"
                      >No Data Available</md-table-cell
                    >
                  </md-table-row>
                  <md-table-row
                    v-else
                    v-for="(item, index) in driver.driver_bank_account"
                    :key="index"
                  >
                    <md-table-cell>{{
                      item.driver_bank_account_bank_name
                    }}</md-table-cell>
                    <md-table-cell>{{
                      item.driver_bank_account_no
                    }}</md-table-cell>
                    <md-table-cell>{{
                      item.driver_bank_account_holder
                    }}</md-table-cell>
                  </md-table-row>
                </md-table>
              </md-card-content>
            </md-card>
          </template>
          <template slot="tab-pane-2">
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <h4 class="title">Registration Fee</h4>
              </md-card-header>
              <md-card-content>
                <md-table>
                  <md-table-row style="background-color:azure">
                    <md-table-head><b>Registration Fee No.</b></md-table-head>
                    <md-table-head><b>Amount</b></md-table-head>
                    <md-table-head><b>Paid Amount</b></md-table-head>
                    <md-table-head><b>Payment Date</b></md-table-head>
                    <md-table-head><b>Status</b></md-table-head>
                  </md-table-row>
                  <md-table-row v-if="driver.driver_status < 3">
                    <md-table-cell colspan="6" class="nodata"
                      >No Data Available</md-table-cell
                    >
                  </md-table-row>
                  <md-table-row
                    v-else
                    v-for="(item, index) in driver.driver_list_dp"
                    :key="index"
                  >
                    <md-table-cell>{{ item.driver_dp_doc_no }}</md-table-cell>
                    <md-table-cell>
                      <span style="float:left">Rp.</span>
                      <span style="float:right; margin-right:80px;">{{
                        formatPrice(item.dp_type.dp_amount)
                      }}</span>
                    </md-table-cell>
                    <md-table-cell>
                      <span style="float:left">Rp.</span>
                      <span style="float:right; margin-right:80px;">{{
                        formatPrice(item.payment_amount)
                      }}</span>
                    </md-table-cell>
                    <md-table-cell>
                      <span v-if="item.payment_history.length != 0">{{
                        item.payment_history[0].payment_at
                      }}</span>
                    </md-table-cell>
                    <md-table-cell>
                      <span v-if="item.driver_dp_status == 0">Unpaid</span>
                      <span v-else-if="item.driver_dp_status == 1"
                        >Partial Paid</span
                      >
                      <span v-else-if="item.driver_dp_status == 2">Paid</span>
                    </md-table-cell>
                  </md-table-row>
                </md-table>
              </md-card-content>
            </md-card>

            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <h4 class="title">History PKO Rental</h4>
              </md-card-header>
              <md-card-content>
                <md-table>
                  <md-table-row style="background-color:azure">
                    <md-table-head><b>PKO No</b></md-table-head>
                    <md-table-head><b>Start Date</b></md-table-head>
                    <md-table-head><b>Estimated End Date</b></md-table-head>
                    <md-table-head><b>Initial Total Payable</b></md-table-head>
                    <md-table-head><b>Paid Amount</b></md-table-head>
                    <md-table-head><b>Remaining Amount</b></md-table-head>
                    <md-table-head><b>Vehicle No</b></md-table-head>
                    <md-table-head><b>Plate No</b></md-table-head>
                    <md-table-head><b>Status</b></md-table-head>
                  </md-table-row>
                  <md-table-row
                    v-for="(item, index) in driver.driver_list_pko"
                    :key="index"
                  >
                    <md-table-cell>{{ item.pko_no }}</md-table-cell>
                    <md-table-cell>{{ item.pko_start_date }}</md-table-cell>
                    <md-table-cell
                      ><span v-if="item.pko_end_date">{{
                        item.pko_end_date
                      }}</span></md-table-cell
                    >

                    <md-table-cell>
                      <span style="float:left">Rp.</span>
                      <span style="float:right">{{
                        formatPrice(item.pko_total_payable)
                      }}</span>
                    </md-table-cell>
                    <md-table-cell>
                      <span style="float:left">Rp.</span>
                      <span style="float:right">{{
                        formatPrice(item.pko_paid_amount)
                      }}</span>
                    </md-table-cell>
                    <md-table-cell>
                      <span style="float:left">Rp.</span>
                      <span style="float:right">{{
                        formatPrice(item.pko_remaining_amount)
                      }}</span>
                    </md-table-cell>
                    <md-table-cell v-if="item.vehicle">{{
                      item.vehicle.vehicle_door_no
                    }}</md-table-cell>
                    <md-table-cell v-if="item.vehicle">{{
                      item.vehicle.vehicle_plate_no
                    }}</md-table-cell>
                    <md-table-cell>
                      <span v-if="item.current_status.status == 0"
                        >Registered</span
                      >
                      <span v-if="item.current_status.status == 1"
                        >Waiting Approval</span
                      >
                      <span v-if="item.current_status.status == 2"
                        >Rejected</span
                      >
                      <span v-if="item.current_status.status == 3">Active</span>
                      <span v-if="item.current_status.status == 4"
                        >Payment Completed</span
                      >
                      <span v-if="item.current_status.status == 5"
                        >Terminated by Payment</span
                      >
                      <span v-if="item.current_status.status == 6"
                        >Change to Ownership</span
                      >
                    </md-table-cell>
                  </md-table-row>
                  <md-table-row v-if="driver.driver_list_pko.length == 0">
                    <md-table-cell colspan="8" class="nodata"
                      >No Data Available</md-table-cell
                    >
                  </md-table-row>
                </md-table>
              </md-card-content>
            </md-card>

            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <h4 class="title">History PKO Ownership</h4>
              </md-card-header>
              <md-card-content>
                <md-table>
                  <md-table-row style="background-color:azure">
                    <md-table-head><b>PKO No</b></md-table-head>
                    <md-table-head><b>Start Date</b></md-table-head>
                    <md-table-head><b>Estimated End Date</b></md-table-head>
                    <md-table-head><b>Initial Total Payable</b></md-table-head>
                    <md-table-head><b>Paid Amount</b></md-table-head>
                    <md-table-head><b>Remaining Amount</b></md-table-head>
                    <md-table-head><b>Vehicle No</b></md-table-head>
                    <md-table-head><b>Plate No</b></md-table-head>
                    <md-table-head><b>Status</b></md-table-head>
                  </md-table-row>
                  <md-table-row
                    v-for="(item, index) in driver.driver_list_pko_ownership"
                    :key="index"
                  >
                    <md-table-cell>{{ item.pko_no }}</md-table-cell>
                    <md-table-cell>{{ item.pko_start_date }}</md-table-cell>
                    <md-table-cell
                      ><span v-if="item.pko_end_date">{{
                        item.pko_end_date
                      }}</span></md-table-cell
                    >

                    <md-table-cell>
                      <span style="float:left">Rp.</span>
                      <span style="float:right">{{
                        formatPrice(item.pko_total_payable)
                      }}</span>
                    </md-table-cell>
                    <md-table-cell>
                      <span style="float:left">Rp.</span>
                      <span style="float:right">{{
                        formatPrice(item.pko_paid_amount)
                      }}</span>
                    </md-table-cell>
                    <md-table-cell>
                      <span style="float:left">Rp.</span>
                      <span style="float:right">{{
                        formatPrice(item.pko_remaining_amount)
                      }}</span>
                    </md-table-cell>
                    <md-table-cell v-if="item.vehicle">{{
                      item.vehicle.vehicle_door_no
                    }}</md-table-cell>
                    <md-table-cell v-if="item.vehicle">{{
                      item.vehicle.vehicle_plate_no
                    }}</md-table-cell>
                    <md-table-cell>
                      <span v-if="item.current_status.status == 0"
                        >Registered</span
                      >
                      <span v-if="item.current_status.status == 1"
                        >Waiting Approval</span
                      >
                      <span v-if="item.current_status.status == 2"
                        >Rejected</span
                      >
                      <span v-if="item.current_status.status == 3">Active</span>
                      <span v-if="item.current_status.status == 4"
                        >Payment Completed</span
                      >
                      <span v-if="item.current_status.status == 5"
                        >Terminated by Payment</span
                      >
                      <span v-if="item.current_status.status == 6"
                        >Change to Ownership</span
                      >
                    </md-table-cell>
                  </md-table-row>
                  <md-table-row
                    v-if="driver.driver_list_pko_ownership.length == 0"
                  >
                    <md-table-cell colspan="8" class="nodata"
                      >No Data Available</md-table-cell
                    >
                  </md-table-row>
                </md-table>
              </md-card-content>
            </md-card>

            <md-card
              style="margin-top:20mm;"
              v-if="driver.driver_pko_active != null"
            >
              <md-card-header class="md-card-header-text md-card-header-blue">
                <h4 class="title">SPJ (PKO Active)</h4>
              </md-card-header>
              <md-card-content>
                <md-table>
                  <md-table-row style="background-color:azure">
                     <md-table-head><b>PKO No</b></md-table-head> 
                     <md-table-head><b>SPJ No</b></md-table-head>
                    <md-table-head><b>Start Date</b></md-table-head>
                    <md-table-head><b>Due Date</b></md-table-head>
                    <md-table-head><b>Weekly</b></md-table-head>
                    <md-table-head><b>Penalty</b></md-table-head>
                    <md-table-head><b>Total Payable</b></md-table-head>
                    <md-table-head><b>Paid Amount</b></md-table-head>
                    <md-table-head><b>Status</b></md-table-head>
                  </md-table-row>
                  <md-table-row
                    v-for="(item, index) in driver.driver_pko_active.spj"
                    :key="index"
                  >
                    <md-table-cell>{{ item.spj_no }}</md-table-cell>
                    <md-table-cell>{{ item.spj_start_date }}</md-table-cell>
                    <md-table-cell>{{ item.spj_due_date }}</md-table-cell>
                    <md-table-cell>
                      <span style="float:left">Rp.</span>
                      <span style="float:right">{{
                        formatPrice(item.spj_weekly_installment)
                      }}</span>
                    </md-table-cell>
                    <md-table-cell>
                      <span style="float:left">Rp.</span>
                      <span style="float:right">{{
                        formatPrice(item.spj_penalty)
                      }}</span>
                    </md-table-cell>
                    <md-table-cell>
                      <span style="float:left">Rp.</span>
                      <span style="float:right">{{
                        formatPrice(
                          item.spj_weekly_installment + item.spj_penalty
                        )
                      }}</span>
                    </md-table-cell>
                    <md-table-cell>
                      <span style="float:left">Rp.</span>
                      <span style="float:right">{{
                        formatPrice(item.payment_amount)
                      }}</span>
                    </md-table-cell>
                    <md-table-cell v-if="item.current_status">
                      <span v-if="item.current_status.status == 0"
                        >Registered</span
                      >
                      <span v-if="item.current_status.status == 1"
                        >Partially Paid</span
                      >
                      <span v-if="item.current_status.status == 2">Paid</span>
                      <span v-if="item.current_status.status == 3">Unpaid</span>
                      <span v-if="item.current_status.status == 4">Active</span>
                    </md-table-cell>
                    <md-table-cell v-else> </md-table-cell>
                  </md-table-row>
                </md-table>
              </md-card-content>
            </md-card>

            <md-card
              style="margin-top:20mm;"
              v-if="driver.driver_pko_ownership_active != null"
            >
              <md-card-header class="md-card-header-text md-card-header-blue">
                <h4 class="title">SPJ (PKO Ownership Active)</h4>
              </md-card-header>
              <md-card-content>
                <md-table>
                  <md-table-row style="background-color:azure">
                     <md-table-head><b>PKO No</b></md-table-head> 
                    <md-table-head><b>SPJ No</b></md-table-head>
                    <md-table-head><b>Start Date</b></md-table-head>
                    <md-table-head><b>Due Date</b></md-table-head>
                    <md-table-head><b>Weekly</b></md-table-head>
                    <md-table-head><b>Penalty</b></md-table-head>
                    <md-table-head><b>Total Payable</b></md-table-head>
                    <md-table-head><b>Paid Amount</b></md-table-head>
                    <md-table-head><b>Status</b></md-table-head>
                  </md-table-row>
                  <md-table-row
                    v-for="(item, index) in driver.driver_pko_ownership_active
                      .spj"
                    :key="index"
                  >
                    <md-table-cell>{{ item.spj_no }}</md-table-cell>
                    <md-table-cell>{{ item.spj_start_date }}</md-table-cell>
                    <md-table-cell>{{ item.spj_due_date }}</md-table-cell>
                    <md-table-cell>
                      <span style="float:left">Rp.</span>
                      <span style="float:right">{{
                        formatPrice(item.spj_weekly_installment)
                      }}</span>
                    </md-table-cell>
                    <md-table-cell>
                      <span style="float:left">Rp.</span>
                      <span style="float:right">{{
                        formatPrice(item.spj_penalty)
                      }}</span>
                    </md-table-cell>
                    <md-table-cell>
                      <span style="float:left">Rp.</span>
                      <span style="float:right">{{
                        formatPrice(
                          item.spj_weekly_installment + item.spj_penalty
                        )
                      }}</span>
                    </md-table-cell>
                    <md-table-cell>
                      <span style="float:left">Rp.</span>
                      <span style="float:right">{{
                        formatPrice(item.payment_amount)
                      }}</span>
                    </md-table-cell>
                    <md-table-cell v-if="item.current_status">
                      <span v-if="item.current_status.status == 0"
                        >Registered</span
                      >
                      <span v-if="item.current_status.status == 1"
                        >Partially Paid</span
                      >
                      <span v-if="item.current_status.status == 2">Paid</span>
                      <span v-if="item.current_status.status == 3">Unpaid</span>
                      <span v-if="item.current_status.status == 4">Active</span>
                    </md-table-cell>
                    <md-table-cell v-else> </md-table-cell>
                  </md-table-row>
                </md-table>
              </md-card-content>
            </md-card>
          </template>

          <template slot="tab-pane-3">
            <md-card> -->
      <!-- <md-card-header
              class="md-card-header-text md-card-header-green"
            >
                <h4 class="title">Document</h4>
            </md-card-header> -->
      <!-- <md-card-content>
                <v-app class="md-layout-item md-size-100">
                  <v-card-title>
                    <v-btn
                      color="primary"
                      dark
                      class="ma-2"
                      @click="openAddPenalty(driver.id)"
                      v-if="role.create"
                    >
                      Add Penalty
                    </v-btn>
                  </v-card-title>
                  <v-data-table
                    mobile-breakpoint
                    :headers="headers"
                    :items="driver_penalty"
                    :loading="loadTable"
                    loading-text="Loading... Please wait"
                    ref="vTable"
                    fixed-header
                    :options.sync="options"
                    :server-items-length="totalDataTable"
                    :page="page"
                    :pageCount="numberOfPages"
                    :footer-props="{ 'items-per-page-options': [15, 25, 50] }"
                  >
                    <template
                      v-slot:[`item.vehicle_ownership_body_color`]="{ item }"
                    >
                      <span v-if="item.vehicle_ownership_body_color == 0"
                        >Putih</span
                      >
                      <span v-if="item.vehicle_ownership_body_color == 1"
                        >Putih Kuning</span
                      >
                      <span v-if="item.vehicle_ownership_body_color == 2"
                        >Putih Metalik</span
                      >
                      <span v-if="item.vehicle_ownership_body_color == 3"
                        >Hitam</span
                      >
                      <span v-if="item.vehicle_ownership_body_color == 4"
                        >Hitam Metalik</span
                      >
                      <span v-if="item.vehicle_ownership_body_color == 5"
                        >Silver</span
                      >
                      <span v-if="item.vehicle_ownership_body_color == 6"
                        >Silver Metalik</span
                      >
                      <span v-if="item.vehicle_ownership_body_color == 7"
                        >Abu Abu
                      </span>
                      <span v-if="item.vehicle_ownership_body_color == 8"
                        >Abu Abu Metalik</span
                      >
                      <span v-if="item.vehicle_ownership_body_color == 9"
                        >N/A</span
                      >
                    </template>

                    <template
                      v-slot:[`item.vehicle_ownership_created_by`]="{ item }"
                    >
                      <span v-if="item.vehicle_ownership_created_by != null">{{
                        item.vehicle_ownership_created_by.name
                      }}</span>
                    </template>

                    <template
                      v-slot:[`item.vehicle_ownership_updated_by`]="{ item }"
                    >
                      <span v-if="item.vehicle_ownership_updated_by != null">{{
                        item.vehicle_ownership_updated_by.name
                      }}</span>
                    </template>

                    <template v-slot:[`item.actions`]="{ item }">
                      <md-button
                        class="md-dense md-icon-button md-info"
                        v-if="role.update"
                        v-on:click="openEditOwnership(item.id)"
                      >
                        <md-icon>edit</md-icon>
                      </md-button>
                    </template>
                  </v-data-table>
                </v-app>
              </md-card-content>
            </md-card>
          </template>

          <template slot="tab-pane-4">
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-blue">
                <h4 class="title">History Payment</h4>
              </md-card-header>
              <md-card-content>
                <md-table>
                  <md-table-row style="background-color:azure">
                    <md-table-head><b>Payment No</b></md-table-head>
                    <md-table-head><b>Payment Date</b></md-table-head>
                    <md-table-head><b>Cashier Name</b></md-table-head>
                    <md-table-head><b>Ref No</b></md-table-head>
                    <md-table-head><b>Payment Method</b></md-table-head>
                    <md-table-head><b>Payment Amount</b></md-table-head>
                    <md-table-head><b>Payment Type</b></md-table-head>
                  </md-table-row>
                  <md-table-row
                    v-if="driver.driver_payment_history.length == 0"
                  >
                    <md-table-cell colspan="6" class="nodata"
                      >No Data Available</md-table-cell
                    >
                  </md-table-row>
                  <md-table-row
                    v-else
                    v-for="(item, index) in driver.driver_payment_history"
                    :key="index"
                  >
                    <md-table-cell>{{ item.payment_no }}</md-table-cell>
                    <md-table-cell>{{ item.payment_at }}</md-table-cell>
                    <md-table-cell>{{
                      item.payment_cashier_name
                    }}</md-table-cell>
                    <md-table-cell>{{ item.payment_ref_no }}</md-table-cell>
                    <md-table-cell>
                      <span v-if="item.payment_method == 1">Cash</span>
                      <span v-if="item.payment_method == 2">Transfer</span>
                      <span v-if="item.payment_method == 3">Debit</span>
                      <span v-if="item.payment_method == 4"
                        >Virtual Account</span
                      >
                    </md-table-cell>
                    <md-table-cell>{{
                      item.payment_receive_amount
                    }}</md-table-cell>
                    <md-table-cell>
                      <span v-if="item.payment_type == 1"
                        >Registration Fee</span
                      >
                      <span v-if="item.payment_type == 2">Rental Fee</span>
                      <span v-if="item.payment_type == 3">Service Dp</span>
                    </md-table-cell>
                  </md-table-row>
                </md-table>
              </md-card-content>
            </md-card>
          </template>
        </tabs> 
      </div> -->

      <template>
        <md-card>
          <!-- <md-card-content> -->
          <v-app>
            <v-card>
              <v-tabs
                color="deep-purple accent-4"
                show-arrows
                centered
                v-model="tab"
              >
                <v-tabs-slider color="teal lighten-3"></v-tabs-slider>

                <v-tab :href="'#tab-1'">
                  <b>Document</b>
                </v-tab>
                <v-tab :href="'#tab-2'">
                  <b>Registration Fee & PKO</b>
                </v-tab>
                <!-- <v-tab :href="'#tab-3'">
                  <b>Penalty</b>
                </v-tab> -->
                <v-tab :href="'#tab-3'">
                  <b>Additional Fee</b>
                </v-tab>
                <v-tab :href="'#tab-4'">
                  <b>Payment History</b>
                </v-tab>
                <!-- <v-tab :href="'#tab-5'">
                    <b>Vehicle Ownership</b>
                  </v-tab> -->
              </v-tabs>

              <v-tabs-items v-model="tab">
                <v-tab-item :key="1" value="tab-1">
                  <v-card class="col-lg">
                    <v-card class="mb-5">
                      <v-card-title>
                        Identity
                      </v-card-title>
                      <!-- <md-card-content> -->
                      <md-table>
                        <md-table-row style="background-color: azure;">
                          <md-table-head><b>Type</b></md-table-head>
                          <md-table-head><b>Identity No</b></md-table-head>
                          <md-table-head><b>Expire Date</b></md-table-head>
                          <md-table-head><b>Place of Issue</b></md-table-head>
                          <md-table-head><b>Address</b></md-table-head>
                          <md-table-head style="text-align:center;"
                            ><b>Photo</b></md-table-head
                          >
                        </md-table-row>
                        <md-table-row v-if="driver.driver_identity.length == 0">
                          <md-table-cell colspan="6" class="nodata"
                            >No Data Available</md-table-cell
                          >
                        </md-table-row>
                        <md-table-row
                          v-else
                          v-for="(item, index) in driver.driver_identity"
                          :key="index"
                        >
                          <md-table-cell>
                            <span v-if="item.driver_identity_type == 0"
                              >KTP</span
                            >
                            <span v-if="item.driver_identity_type == 1"
                              >SKCK</span
                            >
                            <span v-if="item.driver_identity_type == 2"
                              >Domisili</span
                            >
                            <span v-if="item.driver_identity_type == 3"
                              >KK</span
                            >
                          </md-table-cell>
                          <md-table-cell>{{
                            item.driver_identity_no
                          }}</md-table-cell>
                          <md-table-cell>{{
                            item.driver_identity_expire_date
                          }}</md-table-cell>
                          <md-table-cell>{{
                            item.driver_identity_place_of_issue
                          }}</md-table-cell>
                          <md-table-cell>{{
                            item.driver_identity_address
                          }}</md-table-cell>
                          <md-table-cell style="text-align:center;">
                            <span v-if="item.url_driver_identity_file"
                              ><a
                                v-if="item.url_driver_identity_file"
                                :href="item.url_driver_identity_file"
                                target="_blank"
                              >
                                View Photo</a
                              >
                            </span>
                            <span
                              v-else
                              class="nodata"
                              style="text-align:center;"
                              >-</span
                            >
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                      <!-- </md-card-content> -->
                    </v-card>

                    <v-card class="mb-5">
                      <v-card-title>
                        License
                      </v-card-title>
                      <!-- <md-card-content> -->
                      <md-table>
                        <md-table-row style="background-color: azure;">
                          <md-table-head><b>license Type</b></md-table-head>
                          <md-table-head><b>license No</b></md-table-head>
                          <md-table-head><b>Expire Date</b></md-table-head>
                          <md-table-head><b>Address</b></md-table-head>
                          <md-table-head style="text-align:center;"
                            ><b>Photo</b></md-table-head
                          >
                        </md-table-row>
                        <md-table-row v-if="driver.driver_license.length == 0">
                          <md-table-cell colspan="6" class="nodata"
                            >No Data Available</md-table-cell
                          >
                        </md-table-row>
                        <md-table-row
                          v-else
                          v-for="(item, index) in driver.driver_license"
                          :key="index"
                        >
                          <md-table-cell>
                            <span v-if="item.driver_license_type == 0">A</span>
                            <span v-if="item.driver_license_type == 1"
                              >A Umum</span
                            >
                            <span v-if="item.driver_license_type == 2">B</span>
                            <span v-if="item.driver_license_type == 3">B2</span>
                            <span v-if="item.driver_license_type == 4"
                              >B2 Umum</span
                            >
                            <span v-if="item.driver_license_type == 5">C</span>
                            <span v-if="item.driver_license_type == 6">B1</span>
                            <span v-if="item.driver_license_type == 6"
                              >B1 Umum</span
                            >
                          </md-table-cell>
                          <md-table-cell>{{
                            item.driver_license_no
                          }}</md-table-cell>
                          <md-table-cell>{{
                            item.driver_license_expire_date
                          }}</md-table-cell>
                          <md-table-cell>{{
                            item.driver_license_address
                          }}</md-table-cell>
                          <md-table-cell style="text-align:center;">
                            <span v-if="item.url_driver_license_file"
                              ><a
                                v-if="item.url_driver_license_file"
                                :href="item.url_driver_license_file"
                                target="_blank"
                              >
                                View Photo</a
                              >
                            </span>
                            <span
                              v-else
                              class="nodata"
                              style="text-align:center;"
                              >-</span
                            >
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                      <!-- </md-card-content> -->
                    </v-card>

                    <v-card class="mb-5">
                      <v-card-title>
                        Bank Account
                      </v-card-title>
                      <!-- <md-card-content> -->
                      <md-table>
                        <md-table-row style="background-color:azure">
                          <md-table-head><b>Bank Name</b></md-table-head>
                          <md-table-head><b>Account No</b></md-table-head>
                          <md-table-head
                            ><b>Bank Account Holder</b></md-table-head
                          >
                        </md-table-row>
                        <md-table-row
                          v-if="driver.driver_bank_account.length == 0"
                        >
                          <md-table-cell colspan="6" class="nodata"
                            >No Data Available</md-table-cell
                          >
                        </md-table-row>
                        <md-table-row
                          v-else
                          v-for="(item, index) in driver.driver_bank_account"
                          :key="index"
                        >
                          <md-table-cell>{{
                            item.driver_bank_account_bank_name
                          }}</md-table-cell>
                          <md-table-cell>{{
                            item.driver_bank_account_no
                          }}</md-table-cell>
                          <md-table-cell>{{
                            item.driver_bank_account_holder
                          }}</md-table-cell>
                        </md-table-row>
                      </md-table>
                      <!-- </md-card-content> -->
                    </v-card>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>

              <v-tabs-items v-model="tab">
                <v-tab-item :key="2" value="tab-2">
                  <v-card class="col-lg">
                    <v-card class="mb-5">
                      <v-card-title>
                        Registration Fee
                      </v-card-title>
                      <!-- <md-card-content> -->
                      <md-table>
                        <md-table-row style="background-color:azure">
                          <md-table-head
                            ><b>Registration Fee No.</b></md-table-head
                          >
                          <md-table-head><b>Amount</b></md-table-head>
                          <md-table-head><b>Paid Amount</b></md-table-head>
                          <md-table-head><b>Payment Date</b></md-table-head>
                          <md-table-head><b>Status</b></md-table-head>
                        </md-table-row>
                        <md-table-row v-if="driver.driver_status < 3">
                          <md-table-cell colspan="6" class="nodata"
                            >No Data Available</md-table-cell
                          >
                        </md-table-row>
                        <md-table-row
                          v-else
                          v-for="(item, index) in driver.driver_list_dp"
                          :key="index"
                        >
                          <md-table-cell>{{
                            item.driver_dp_doc_no
                          }}</md-table-cell>
                          <md-table-cell>
                            <span style="float:left">Rp.</span>
                            <span style="float:right; margin-right:80px;">{{
                              formatPrice(item.dp_type.dp_amount)
                            }}</span>
                          </md-table-cell>
                          <md-table-cell>
                            <span style="float:left">Rp.</span>
                            <span style="float:right; margin-right:80px;">{{
                              formatPrice(item.payment_amount)
                            }}</span>
                          </md-table-cell>
                          <md-table-cell>
                            <span v-if="item.payment_history.length != 0">{{
                              item.payment_history[0].payment_at
                            }}</span>
                          </md-table-cell>
                          <md-table-cell>
                            <span v-if="item.driver_dp_status == 0"
                              >Unpaid</span
                            >
                            <span v-else-if="item.driver_dp_status == 1"
                              >Partial Paid</span
                            >
                            <span v-else-if="item.driver_dp_status == 2"
                              >Paid</span
                            >
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                      <!-- </md-card-content> -->
                    </v-card>

                    <v-card class="mb-5">
                      <v-card-title>
                        History PKO Rental
                      </v-card-title>
                      <md-card-content>
                        <md-table>
                          <md-table-row style="background-color:azure">
                            <md-table-head><b>PKO No</b></md-table-head>
                            <md-table-head><b>Start Date</b></md-table-head>
                            <md-table-head
                              ><b>Estimated End Date</b></md-table-head
                            >
                            <md-table-head
                              ><b>Initial Total Payable</b></md-table-head
                            >
                            <md-table-head><b>Paid Amount</b></md-table-head>
                            <md-table-head
                              ><b>Remaining Amount</b></md-table-head
                            >
                            <md-table-head><b>Vehicle No</b></md-table-head>
                            <md-table-head><b>Plate No</b></md-table-head>
                            <md-table-head><b>Status</b></md-table-head>
                          </md-table-row>
                          <md-table-row
                            v-for="(item, index) in driver.driver_list_pko"
                            :key="index"
                          >
                            <md-table-cell>{{ item.pko_no }}</md-table-cell>
                            <md-table-cell>{{
                              item.pko_start_date
                            }}</md-table-cell>
                            <md-table-cell
                              ><span v-if="item.pko_end_date">{{
                                item.pko_end_date
                              }}</span></md-table-cell
                            >

                            <md-table-cell>
                              <span style="float:left">Rp.</span>
                              <span style="float:right">{{
                                formatPrice(item.pko_total_payable)
                              }}</span>
                            </md-table-cell>
                            <md-table-cell>
                              <span style="float:left">Rp.</span>
                              <span style="float:right">{{
                                formatPrice(item.pko_paid_amount)
                              }}</span>
                            </md-table-cell>
                            <md-table-cell>
                              <span style="float:left">Rp.</span>
                              <span style="float:right">{{
                                formatPrice(item.pko_remaining_amount)
                              }}</span>
                            </md-table-cell>
                            <md-table-cell v-if="item.vehicle">{{
                              item.vehicle.vehicle_door_no
                            }}</md-table-cell>
                            <md-table-cell v-if="item.vehicle">{{
                              item.vehicle.vehicle_plate_no
                            }}</md-table-cell>
                            <md-table-cell>
                              <span v-if="item.current_status.status == 0"
                                >Registered</span
                              >
                              <span v-if="item.current_status.status == 1"
                                >Waiting Approval</span
                              >
                              <span v-if="item.current_status.status == 2"
                                >Rejected</span
                              >
                              <span v-if="item.current_status.status == 3"
                                >Active</span
                              >
                              <span v-if="item.current_status.status == 4"
                                >Payment Completed</span
                              >
                              <span v-if="item.current_status.status == 5"
                                >Terminated by Payment <span v-if="item.pko_terminate_date!=null">At {{ item.pko_terminate_date }}</span></span
                              >
                              <span v-if="item.current_status.status == 6"
                                >Change to Ownership</span
                              >
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row
                            v-if="driver.driver_list_pko.length == 0"
                          >
                            <md-table-cell colspan="8" class="nodata"
                              >No Data Available</md-table-cell
                            >
                          </md-table-row>
                        </md-table>
                      </md-card-content>
                    </v-card>

                   

                    <v-card
                      class="mb-5"
                      v-if="driver.driver_pko_active != null"
                    >
                      <v-card-title>
                        SPJ (PKO Active)
                      </v-card-title>
                      <!-- <md-card-content> -->
                      <md-table>
                        <md-table-row style="background-color:azure">
                          <!-- <md-table-head><b>PKO No</b></md-table-head> -->
                          <md-table-head><b>SPJ No</b></md-table-head>
                          <md-table-head><b>Start Date</b></md-table-head>
                          <md-table-head><b>Due Date</b></md-table-head>
                          <md-table-head><b>Weekly</b></md-table-head>
                          <md-table-head><b>Penalty</b></md-table-head>
                          <md-table-head><b>Total Payable</b></md-table-head>
                          <md-table-head><b>Paid Amount</b></md-table-head>
                          <md-table-head><b>Status</b></md-table-head>
                        </md-table-row>
                        <md-table-row
                          v-for="(item, index) in driver.driver_pko_active.spj"
                          :key="index"
                        >
                          <md-table-cell>{{ item.spj_no }}</md-table-cell>
                          <md-table-cell>{{
                            item.spj_start_date
                          }}</md-table-cell>
                          <md-table-cell>{{ item.spj_due_date }}</md-table-cell>
                          <md-table-cell>
                            <span style="float:left">Rp.</span>
                            <span style="float:right">{{
                              formatPrice(item.spj_weekly_installment)
                            }}</span>
                          </md-table-cell>
                          <md-table-cell>
                            <span style="float:left">Rp.</span>
                            <span style="float:right">{{
                              formatPrice(item.spj_penalty)
                            }}</span>
                          </md-table-cell>
                          <md-table-cell>
                            <span style="float:left">Rp.</span>
                            <span style="float:right">{{
                              formatPrice(
                                item.spj_weekly_installment + item.spj_penalty
                              )
                            }}</span>
                          </md-table-cell>
                          <md-table-cell>
                            <span style="float:left">Rp.</span>
                            <span style="float:right">{{
                              formatPrice(item.payment_amount)
                            }}</span>
                          </md-table-cell>
                          <md-table-cell v-if="item.current_status">
                            <span v-if="item.current_status.status == 0"
                              >Registered</span
                            >
                            <span v-if="item.current_status.status == 1"
                              >Partially Paid</span
                            >
                            <span v-if="item.current_status.status == 2"
                              >Paid</span
                            >
                            <span v-if="item.current_status.status == 3"
                              >Unpaid</span
                            >
                            <span v-if="item.current_status.status == 4"
                              >Active</span
                            >
                          </md-table-cell>
                          <md-table-cell v-else> </md-table-cell>
                        </md-table-row>
                      </md-table>
                      <!-- </md-card-content> -->
                    </v-card>

                    <v-card
                      class="mb-5"
                      v-if="driver.driver_pko_ownership_active != null"
                    >
                      <v-card-title>
                        SPJ (PKO Ownership Active)
                      </v-card-title>
                      <!-- <md-card-content> -->
                      <md-table>
                        <md-table-row style="background-color:azure">
                          <!-- <md-table-head><b>PKO No</b></md-table-head> -->
                          <md-table-head><b>SPJ No</b></md-table-head>
                          <md-table-head><b>Start Date</b></md-table-head>
                          <md-table-head><b>Due Date</b></md-table-head>
                          <md-table-head><b>Weekly</b></md-table-head>
                          <md-table-head><b>Penalty</b></md-table-head>
                          <md-table-head><b>Total Payable</b></md-table-head>
                          <md-table-head><b>Paid Amount</b></md-table-head>
                          <md-table-head><b>Status</b></md-table-head>
                        </md-table-row>
                        <md-table-row
                          v-for="(item, index) in driver
                            .driver_pko_ownership_active.spj"
                          :key="index"
                        >
                          <md-table-cell>{{ item.spj_no }}</md-table-cell>
                          <md-table-cell>{{
                            item.spj_start_date
                          }}</md-table-cell>
                          <md-table-cell>{{ item.spj_due_date }}</md-table-cell>
                          <md-table-cell>
                            <span style="float:left">Rp.</span>
                            <span style="float:right">{{
                              formatPrice(item.spj_weekly_installment)
                            }}</span>
                          </md-table-cell>
                          <md-table-cell>
                            <span style="float:left">Rp.</span>
                            <span style="float:right">{{
                              formatPrice(item.spj_penalty)
                            }}</span>
                          </md-table-cell>
                          <md-table-cell>
                            <span style="float:left">Rp.</span>
                            <span style="float:right">{{
                              formatPrice(
                                item.spj_weekly_installment + item.spj_penalty
                              )
                            }}</span>
                          </md-table-cell>
                          <md-table-cell>
                            <span style="float:left">Rp.</span>
                            <span style="float:right">{{
                              formatPrice(item.payment_amount)
                            }}</span>
                          </md-table-cell>
                          <md-table-cell v-if="item.current_status">
                            <span v-if="item.current_status.status == 0"
                              >Registered</span
                            >
                            <span v-if="item.current_status.status == 1"
                              >Partially Paid</span
                            >
                            <span v-if="item.current_status.status == 2"
                              >Paid</span
                            >
                            <span v-if="item.current_status.status == 3"
                              >Unpaid</span
                            >
                            <span v-if="item.current_status.status == 4"
                              >Active</span
                            >
                          </md-table-cell>
                          <md-table-cell v-else> </md-table-cell>
                        </md-table-row>
                      </md-table>
                      <!-- </md-card-content> -->
                    </v-card>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>

              <v-tabs-items v-model="tab">
                <v-tab-item :key="3" value="tab-3">
                  <v-card class="col-lg">
                    <v-card-title>
                      <v-btn
                        color="primary"
                        dark
                        class="ma-2"
                        @click="modalOpenAddFormList()"
                      >
                        Add Additional Fee
                      </v-btn>
                    </v-card-title>
                    <md-table>
                      <md-table-row style="background-color:azure">
                        <md-table-head><b>Action</b></md-table-head>
                        <md-table-head><b>Status</b></md-table-head>
                        <md-table-head><b>Fee No</b></md-table-head>
                        <md-table-head><b>Name</b></md-table-head>
                        <md-table-head><b>Type</b></md-table-head>
                        <md-table-head><b>Amount</b></md-table-head>
                        <md-table-head><b>Remark</b></md-table-head>
                        <md-table-head><b>Created At</b></md-table-head>
                      </md-table-row>
                      <md-table-row v-if="driver.driver_additional_fee.length == 0">
                        <md-table-cell colspan="8" class="nodata"
                        >No Data Available</md-table-cell>
                      </md-table-row>
                      <md-table-row v-else v-for="(item,index) in driver.driver_additional_fee" :key="index">
                        <md-table-cell>
                          <v-menu  offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                color="primary"
                                dark
                                x-small
                                v-bind="attrs"
                                v-on="on"
                                
                              >
                                <v-icon dark x-small>
                                  mdi-format-list-bulleted-square
                                </v-icon>
                              </v-btn>
                            </template>
                            <v-list>
                              <v-list-item v-if="item.current_status.status==0"  @click="modalOpenEditFormType(item)">
                                <v-list-item-title x-small>Edit</v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </md-table-cell>
                        <md-table-cell>
                          <span v-if="item.current_status.status==0">Registered</span>
                          <span v-if="item.current_status.status==1">Partially Paid</span>
                          <span v-if="item.current_status.status==2">Paid</span>
                        </md-table-cell>
                        <md-table-cell>{{ item.driver_additional_fee_no }}</md-table-cell>
                        <md-table-cell>{{ item.driver_additional_fee_name }}</md-table-cell>
                        <md-table-cell>
                          <span v-if="item.driver_additional_fee_type==1">Repair</span>
                          <span v-if="item.driver_additional_fee_type==2">Penalty</span>
                          <span v-if="item.driver_additional_fee_type==3">Repo</span>
                          <span v-if="item.driver_additional_fee_type==4">OOJ (Out Of Jabodetabek)</span>
                          <span v-if="item.driver_additional_fee_type==5">STNK Extension</span>
                          <span v-if="item.driver_additional_fee_type==6">Remaining PKO Payments</span>
                        </md-table-cell>
                        <md-table-cell>{{ formatPrice(item.driver_additional_fee_amount) }}</md-table-cell>
                        <md-table-cell>{{ item.driver_additional_fee_remark }}</md-table-cell>
                        
                        <md-table-cell>{{ $moment(item.created_at).utc().format('DD-MM-YYYY HH:mm') }}</md-table-cell>
                      </md-table-row>
                        </md-table>
                  </v-card>
                  <!-- <v-card class="col-lg">
                    <v-card class="mb-5">
                      <v-btn
                        color="primary"
                        dark
                        class="ma-2"
                        @click="openAddPenalty(driver.id)"
                        v-if="role.create"
                      >
                        Add Penalty
                      </v-btn>
                      <v-data-table
                        mobile-breakpoint
                        :headers="headers"
                        :items="driver_penalty"
                        :loading="loadTable"
                        loading-text="Loading... Please wait"
                        ref="vTable"
                        fixed-header
                        :options.sync="options"
                        :server-items-length="totalDataTable"
                        :page="page"
                        :pageCount="numberOfPages"
                        :footer-props="{
                          'items-per-page-options': [15, 25, 50],
                        }"
                      >
                        <template
                          v-slot:[`item.vehicle_ownership_body_color`]="{
                            item,
                          }"
                        >
                          <span v-if="item.vehicle_ownership_body_color == 0"
                            >Putih</span
                          >
                          <span v-if="item.vehicle_ownership_body_color == 1"
                            >Putih Kuning</span
                          >
                          <span v-if="item.vehicle_ownership_body_color == 2"
                            >Putih Metalik</span
                          >
                          <span v-if="item.vehicle_ownership_body_color == 3"
                            >Hitam</span
                          >
                          <span v-if="item.vehicle_ownership_body_color == 4"
                            >Hitam Metalik</span
                          >
                          <span v-if="item.vehicle_ownership_body_color == 5"
                            >Silver</span
                          >
                          <span v-if="item.vehicle_ownership_body_color == 6"
                            >Silver Metalik</span
                          >
                          <span v-if="item.vehicle_ownership_body_color == 7"
                            >Abu Abu
                          </span>
                          <span v-if="item.vehicle_ownership_body_color == 8"
                            >Abu Abu Metalik</span
                          >
                          <span v-if="item.vehicle_ownership_body_color == 9"
                            >N/A</span
                          >
                        </template>

                        <template
                          v-slot:[`item.vehicle_ownership_created_by`]="{
                            item,
                          }"
                        >
                          <span
                            v-if="item.vehicle_ownership_created_by != null"
                            >{{ item.vehicle_ownership_created_by.name }}</span
                          >
                        </template>

                        <template
                          v-slot:[`item.vehicle_ownership_updated_by`]="{
                            item,
                          }"
                        >
                          <span
                            v-if="item.vehicle_ownership_updated_by != null"
                            >{{ item.vehicle_ownership_updated_by.name }}</span
                          >
                        </template>

                        <template v-slot:[`item.actions`]="{ item }">
                          <md-button
                            class="md-dense md-icon-button md-info"
                            v-if="role.update"
                            v-on:click="openEditOwnership(item.id)"
                          >
                            <md-icon>edit</md-icon>
                          </md-button>
                        </template>
                      </v-data-table>
                    </v-card>
                  </v-card> -->
                </v-tab-item>
              </v-tabs-items>

              <v-tabs-items v-model="tab">
                <v-tab-item :key="4" value="tab-4">
                  <v-card class="col-lg">
                    <v-card class="mb-5">
                      <v-card-title>
                        History Payment
                      </v-card-title>
                      <md-table>
                        <md-table-row style="background-color:azure">
                          <md-table-head><b>Payment No</b></md-table-head>
                          <md-table-head><b>Payment Date</b></md-table-head>
                          <md-table-head><b>Cashier Name</b></md-table-head>
                          <md-table-head><b>Ref No</b></md-table-head>
                          <md-table-head><b>Payment Method</b></md-table-head>
                          <md-table-head><b>Payment Amount</b></md-table-head>
                          <md-table-head><b>Payment Type</b></md-table-head>
                        </md-table-row>
                        <md-table-row
                          v-if="driver.driver_payment_history.length == 0"
                        >
                          <md-table-cell colspan="6" class="nodata"
                            >No Data Available</md-table-cell
                          >
                        </md-table-row>
                        <md-table-row
                          v-else
                          v-for="(item, index) in driver.driver_payment_history"
                          :key="index"
                        >
                          <md-table-cell>{{ item.payment_no }}</md-table-cell>
                          <md-table-cell>{{ item.payment_at }}</md-table-cell>
                          <md-table-cell>{{
                            item.payment_cashier_name
                          }}</md-table-cell>
                          <md-table-cell>{{
                            item.payment_ref_no
                          }}</md-table-cell>
                          <md-table-cell>
                            <span v-if="item.payment_method == 1">Cash</span>
                            <span v-if="item.payment_method == 2"
                              >Transfer</span
                            >
                            <span v-if="item.payment_method == 3">Debit</span>
                            <span v-if="item.payment_method == 4"
                              >Virtual Account</span
                            >
                          </md-table-cell>
                          <md-table-cell>{{
                            item.payment_receive_amount
                          }}</md-table-cell>
                          <md-table-cell>
                            <span v-if="item.payment_type == 1"
                              >Registration Fee</span
                            >
                            <span v-if="item.payment_type == 2"
                              >Rental Fee</span
                            >
                            <span v-if="item.payment_type == 3"
                              >Service Dp</span
                            >
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </v-card>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-app>
        </md-card>
      </template>

      <!-- <div class="md-layout-item md-size-100">
          <md-card>
              <md-card-header class="md-card-header-text md-card-header-blue">
                  <div class="card-text">
                      <h4 class="title">Identity Info</h4>
                  </div>
              </md-card-header>
              <md-card-content>
                  <md-table>
                      <md-table-row>
                          <md-table-head ><b>Identity Type</b></md-table-head>
                          <md-table-head ><b>Identity No</b></md-table-head>
                          <md-table-head ><b>Expire Date</b></md-table-head>
                          <md-table-head ><b>Place of Issue</b></md-table-head>
                          <md-table-head ><b>Address</b></md-table-head>
                          <md-table-head style="text-align:center;"><b>Photo</b></md-table-head>
                      </md-table-row>
                      <md-table-row v-if="driver.driver_identity.length==0">
                          <md-table-cell colspan="6" class="nodata">No Data Available</md-table-cell>
                      </md-table-row>
                      <md-table-row v-else v-for="(item, index)  in driver.driver_identity"
                    :key="index">
                          <md-table-cell >
                              <span v-if="item.driver_identity_type==0">KTP</span>
                              <span v-if="item.driver_identity_type==1">SKCK</span>
                              <span v-if="item.driver_identity_type==2">Domisili</span>
                              <span v-if="item.driver_identity_type==3">KK</span>
                            </md-table-cell>
                          <md-table-cell >{{item.driver_identity_no}}</md-table-cell>
                          <md-table-cell >{{item.driver_identity_expire_date}}</md-table-cell>
                          <md-table-cell >{{item.driver_identity_place_of_issue}}</md-table-cell>
                          <md-table-cell >{{item.driver_identity_address}}</md-table-cell>
                          <md-table-cell >
                            <viewer class="pointer photo_list " :src="item.driver_identity_photo" v-if="item.driver_identity_photo">
                                  <img :src="item.driver_identity_photo" :alt="'driver identity photo '+index " >
                            </viewer>
                            
                        </md-table-cell>
                      </md-table-row>
                  </md-table>
              </md-card-content>
          </md-card>
      </div>

      

      <div class="md-layout-item md-size-100">
          <md-card>
              <md-card-header class="md-card-header-text md-card-header-blue">
                  <div class="card-text">
                      <h4 class="title">License Info</h4>
                  </div>
              </md-card-header>
              <md-card-content>
                  <md-table>
                      <md-table-row>
                          <md-table-head ><b>license Type</b></md-table-head>
                          <md-table-head ><b>license No</b></md-table-head>
                          <md-table-head ><b>Expire Date</b></md-table-head>
                          <md-table-head ><b>Address</b></md-table-head>
                          <md-table-head style="text-align:center;"><b>Photo</b></md-table-head>
                      </md-table-row>
                      <md-table-row v-if="driver.driver_license.length==0">
                          <md-table-cell colspan="6" class="nodata">No Data Available</md-table-cell>
                      </md-table-row>
                      <md-table-row v-else v-for="(item, index)  in driver.driver_license"
                    :key="index">
                          <md-table-cell >
                              <span v-if="item.driver_license_type==0">A</span>
                                <span v-if="item.driver_license_type==1">A1 Umum</span>
                                <span v-if="item.driver_license_type==2">B</span>
                                <span v-if="item.driver_license_type==3">B2</span>
                                <span v-if="item.driver_license_type==4">B2 Umum</span>
                                <span v-if="item.driver_license_type==5">C</span>
                                <span v-if="item.driver_license_type==6">B1</span>
                            </md-table-cell>
                          <md-table-cell >{{item.driver_license_no}}</md-table-cell>
                          <md-table-cell >{{item.driver_license_expire_date}}</md-table-cell>
                          <md-table-cell >{{item.driver_license_address}}</md-table-cell>
                          <md-table-cell >
                            <viewer class="pointer photo_list" :src="item.driver_license_photo" v-if="item.driver_license_photo">
                                  <img :src="item.driver_license_photo" :alt="'driver license photo '+index " >
                            </viewer>
                        </md-table-cell>
                      </md-table-row>
                  </md-table>
              </md-card-content>
          </md-card>
      </div>

      <div class="md-layout-item md-size-100">
          <md-card>
              <md-card-header class="md-card-header-text md-card-header-blue">
                  <div class="card-text">
                      <h4 class="title">Bank Account Info</h4>
                  </div>
              </md-card-header>
              <md-card-content>
                  <md-table>
                      <md-table-row>
                          <md-table-head ><b>Bank Name</b></md-table-head>
                          <md-table-head ><b>Account No</b></md-table-head>
                          <md-table-head ><b>Bank Account Holder</b></md-table-head>
                      </md-table-row>
                      <md-table-row v-if="driver.driver_bank_account.length==0">
                          <md-table-cell colspan="6" class="nodata">No Data Available</md-table-cell>
                      </md-table-row>
                      <md-table-row v-else v-for="(item, index)  in driver.driver_bank_account"
                    :key="index">
                          <md-table-cell >{{item.driver_bank_account_bank_name}}</md-table-cell>
                          <md-table-cell >{{item.driver_bank_account_no}}</md-table-cell>
                          <md-table-cell >{{item.driver_driver_bank_account_holder}}</md-table-cell>
                      </md-table-row>
                  </md-table>
              </md-card-content>
          </md-card>
      </div> -->

      <!-- <div class="md-layout-item md-size-100" >
        <md-tabs  md-alignment="centered" style="margin-top:20px; color:black;">
            <md-tab id="tab-home" md-label="Home" >
            <tab style="padding:0px;">
                <viewer class="pointer photo" src="@/assets/images/avatar.jpg">
                <md-card-media-cover md-solid >
                    
                    <md-card-media>
                        
                    <img  src="@/assets/images/avatar.jpg" alt="Gambar">
                    </md-card-media>

                    <md-card-area>
                    <md-card-header>
                        <span class="md-subhead">Noaa Identity</span>
                        <span class="md-subhead">asdasd</span>
                        <span class="md-subhead">asdas</span>
                        <span class="md-subhead">asdas</span>

                    </md-card-header>
                    </md-card-area>
                    
                </md-card-media-cover>
                    </viewer>
            </tab>

          
          
          
          
          </md-tab>
      <md-tab id="tab-pages" md-label="Pages"></md-tab>
      <md-tab id="tab-posts" md-label="Posts"></md-tab>
      <md-tab id="tab-favorites" md-label="Favorites"></md-tab>
    </md-tabs>
      </div> -->
    </div>

    <div v-bind:style="{ display: not_found }">
      <center v-if="driver == null">
        <h1>Not Found!</h1>
        <p>
          <a href="" @click="backToList()">Back To List?</a>
        </p>
      </center>
    </div>
    <modal ref="modalFormType" class="coba tinggi">
      <template v-slot:header>
        <div>
          <h3>{{ titleFormType }}</h3>
        </div>
        <md-button class="md-dense md-round md-icon-button" @click="modalCloseFormType()"><md-icon>close</md-icon></md-button>
      </template>

      <template v-slot:body>
        <ValidationObserver ref="observer">
          <form ref="add_driver_additional_fee_form" @submit.prevent="submitFormType">
            <md-card>
              <md-card-content>
                <input v-model="id_additioanl_fee" :readonly="true" type="hidden"/>          
                
                <div class="md-layout">
                  <div class="md-layout-item">
                    <validation-provider rules="feename" v-slot="{ errors }">
                    <md-field class="md-invalid">
                      <label for="">Fee Name</label>
                      <md-input v-model="driver_additional_fee_name" required/>
                      <validation-error :errors="apiValidationErrors.driver_additional_fee_name" />
                      <span class="md-error">{{ errors[0] }}</span>
                    </md-field>
                    </validation-provider>
                  </div>
                  <div class="md-layout-item">
                    <validation-provider rules="feetype" v-slot="{ errors }">
                    <md-field class="md-invalid">
                      <label>Fee type</label>
                      <md-select v-model="driver_additional_fee_type" required>
                        <md-option value="1">Repair</md-option>
                        <md-option value="2">Penalty</md-option>
                        <md-option value="3">Repo</md-option>
                        <md-option value="4">OOJ (Out Of Jabodetabek)</md-option>
                        <md-option value="5">STNK extension</md-option>
                      </md-select>
                      <validation-error :errors="apiValidationErrors.driver_additional_fee_type" />
                      <span class="md-error">{{ errors[0] }}</span>
                    </md-field>
                    </validation-provider>
                  </div>
                </div>

                <div class="md-layout">
                  <div class="md-layout-item">
                    <validation-provider rules="feeamount" v-slot="{ errors }">
                    <md-field class="md-invalid">
                      <label>Fee Amount</label>
                      <md-input  type="text" v-on:keypress="NumbersOnly" v-model="driver_additional_fee_amount" required />
                      <validation-error :errors="apiValidationErrors.driver_additional_fee_amount" />
                      <span class="md-error">{{ errors[0] }}</span>
                    </md-field>
                    </validation-provider>
                  </div>
                  <div class="md-layout-item">
                    <validation-provider v-slot="{ errors }">
                    <md-field class="md-invalid">
                      <label>Remark</label>
                      <md-input v-model="driver_additional_fee_remark" />
                      <validation-error :errors="apiValidationErrors.driver_additional_fee_remark" />
                      <span class="md-error">{{ errors[0] }}</span>
                    </md-field>
                    </validation-provider>
                  </div>
                </div>

            
              </md-card-content>
              <md-card-actions>
                <md-button class="md-info md-dense" @click="addConfirmation">
                  submit
                </md-button>
              </md-card-actions>
            </md-card>
          </form>
        </ValidationObserver>
      </template>
    </modal>
  </div>
</template>

<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import Swal from "sweetalert2";
import Viewer from "v-viewer";
import Vue from "vue";
import "viewerjs/dist/viewer.css";
import { Modal } from "@/components";
import { extend, ValidationObserver } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { NavTabsCard } from "@/components";
// import { Tabs } from "@/components";
// import { api as viewerApi } from "v-viewer";import Vue from 'vue'
// import VPopover from 'vue-js-popover'

extend('feename', {
  ...required,
  message: 'Fee Name field is required'
});
extend('feetype', {
  ...required,
  message: 'Type field is required'
});
extend('feeamount', {
  ...required,
  message: 'Amount field is required'
});

Vue.use(Viewer);
const url_storage = process.env.VUE_APP_STORAGE_BASE_URL;
export default {
  computed: {
    headers() {
      const headers = [
        {
          text: "Registration Name",
          value: "vehicle_ownership_registration_name",
          sortable: false,
        },
        {
          text: "Body Color",
          value: "vehicle_ownership_body_color",
          sortable: false,
          width: "150",
        },
        {
          text: "Plate No",
          value: "vehicle_ownership_plate_no",
          sortable: false,
          width: "150",
        },
        {
          text: "Created By",
          value: "vehicle_ownership_created_by",
          sortable: false,
          width: "150",
        },
        {
          text: "Updated By",
          value: "vehicle_ownership_updated_by",
          sortable: false,
          width: "150",
        },
        {
          text: "Change Date",
          value: "vehicle_ownership_change_date",
          sortable: false,
          width: "150",
        },
        { text: "Update At", value: "updated_at", sortable: false },
      ];
      console.log(this.role);
      if (this.role.update) {
        headers.unshift({
          text: "Action",
          value: "actions",
          align: "start",
          sortable: false,
        });
      }

      return headers;
    },
  },

  // watch: {
  //   options: {
  //     handler() {
  //       if (!this.mounted) {
  //         this.getListPenalty();
  //       }
  //     },
  //   },
  //   deep: true,
  // },

  components: {
    Modal,
    ValidationObserver,
    ValidationError
    // Tabs,
  },
  name: "detail-service-estimates",
  props: {
    data_id: null,
  },

  mixins: [formMixin],

  data: () => ({
    options: {},
    loadTable: false,
    totalDataTable: 0,
    page: 1,
    numberOfPages: 0,
    tab: "tab-1",
    role_name: "",
    active: false,
    not_found: "none",
    role: "",
    driver: null,
    url_storage: url_storage,
    driver_penalty: [],
    showDialog: false,
    titleFormType : "Add Outstanding",
    id_additioanl_fee:null,
    driver_additional_fee_name:null,
    driver_additional_fee_type:null,
    driver_additional_fee_amount:null,
    driver_additional_fee_remark:null,
  }),

  created() {
    this.getDriverData();
  },

  methods: {
    //fungsi yang berjalan saat page pertamakali dibuka
    async getDriverData() {
      //ambil list role permission user
      this.role = await this.$store.getters["role_permission/route_filter"];
      var me = await this.$store.getters["profile/me"];
      this.role_name = me.role_name;
      // console.log(this.role)
      //ambil data se sesuai dengan id yang ikut juga dikirim melalui route
      await this.$store.dispatch("fms_driver/get", this.data_id.id);
      this.driver = await this.$store.getters["fms_driver/driver"];
      // this.driver.driver_history_status.updated_at = (new Date()).toISOString().split('T')[0]

      if (!this.driver) {
        this.not_found = "block";
        return;
      }
    },

    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },

    // async getListPenalty() {
    //   this.loadTable = true;
    //   const { page, itemsPerPage, sortBy, sortDesc } = this.options;
    //   console.log(this.options);
    //   let pageNumber = page;

    //   let itemsPerPageNumber = itemsPerPage;

    //   var query = { page: { number: pageNumber, size: itemsPerPageNumber } };
    //   query.filter = { driver_penalty_driver_id: this.data_id.id };
    //   if (sortBy.length != 0) {
    //     var sort = sortBy[0];
    //     if (sortDesc[0]) {
    //       sort = "-" + sortBy[0];
    //     }
    //     query.sort = sort;
    //   }

    //   console.log(query);
    //   await this.$store.dispatch("fms_driver_penalty/list", query);
    //   this.vehicle_ownership = await this.$store.getters[
    //     "fms_driver_penalty/list"
    //   ];
    //   var pageMeta = await this.$store.getters["fms_driver_penalty/page"];
   

    //   this.totalDataTable = pageMeta.total;
    //   this.numberOfPages = pageMeta["to"];
    //   this.loadTable = false;
    // },

    // async closeDetail() {
    //   this.$parent.$parent.modalCloseDetail();
    // },

    async modalOpenAddFormList(){
    this.titleFormType= "Add Oustanding"
    this.resetForm()

      this.$refs.modalFormType.openModal()
    },
    async modalOpenEditFormType(item){
      this.titleFormType= "Edit Outstanding"

      this.id_additioanl_fee= item.id
      this.driver_additional_fee_name = item.driver_additional_fee_name
      this.driver_additional_fee_type= item.driver_additional_fee_type
      this.driver_additional_fee_amount= item.driver_additional_fee_amount
      this.driver_additional_fee_remark= item.driver_additional_fee_remark

      this.$refs.modalFormType.openModal()
    },
    modalCloseFormType(){
      this.$refs.modalFormType.closeModal()
      this.getDriverData();
    },

    async addConfirmation() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
      Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be saved!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, save it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
      }).then((result) => {
        if (result.value){
          this.submitFormType()
        }
      });
    },
    async submitFormType(){
      if(this.id_additioanl_fee==null){
          const data = {
              type: "fms_driver_additional_fees", 
              driver_additional_fee_driver_id: this.data_id.id,
              driver_additional_fee_name: this.driver_additional_fee_name,
              driver_additional_fee_type: this.driver_additional_fee_type,
              driver_additional_fee_amount: this.driver_additional_fee_amount,
              driver_additional_fee_remark: this.driver_additional_fee_remark
            }


            try {
            await this.$store.dispatch("fms_driver_additional_fee/add", data);
            await this.$store.dispatch(
              "alerts/success",
              "Successfully registered."
            );
            //this.table.push(await this.$store.getters["workshop_procurement_order_payment/vehicle_type"])
            this.$refs['add_driver_additional_fee_form'].reset();
            this.resetForm()
            this.modalCloseFormType()
          // await this.$parent.$parent.modalCloseList()
            //await this.$parent.$parent.modalOpenList(this.data_id.id,this.data_id.name)
            } catch (e) {
              console.log(e)
              await this.$store.dispatch(
                "alerts/error",
                "Oops, something went wrong"
              );
              if(e.response){
                this.setApiValidation(e.response.data.errors);
              }
              
            }
      }
      else{
          const data = {
              type: "fms_driver_additional_fees", 
              id: this.id_additioanl_fee.toString(),
              driver_additional_fee_name: this.driver_additional_fee_name,
              driver_additional_fee_type: this.driver_additional_fee_type,
              driver_additional_fee_amount: this.driver_additional_fee_amount,
              driver_additional_fee_remark: this.driver_additional_fee_remark
            }


            try {
            await this.$store.dispatch("fms_driver_additional_fee/update", data);
            await this.$store.dispatch(
              "alerts/success",
              "Successfully updated."
            );
            

            this.$refs['add_driver_additional_fee_form'].reset();
            this.resetForm()
            this.modalCloseFormType()
        
            } catch (e) {
              console.log(e)
              await this.$store.dispatch(
                "alerts/error",
                "Oops, something went wrong"
              );
              if(e.response){
                this.setApiValidation(e.response.data.errors);
              }
            }
      }
      
    },
    resetForm(){
      this.id_additioanl_fee= null
      this.driver_additional_fee_name= null
      this.driver_additional_fee_type = null
      this.driver_additional_fee_amount = null
      this.driver_additional_fee_remark = null
    },

    async closeDetail(){ 
      if(this.data_id.mode && this.data_id.mode == "OD"){
          this.$parent.$parent.closeDriverDetail();
        }
        else if(this.data_id.mode && this.data_id.mode == "PKOBP"){
          this.$parent.$parent.closeDriverPKODetail();
        }
        else if(this.data_id.mode && this.data_id.mode == "PKOOBP"){
          this.$parent.$parent.closeDriverPKOOBPDetail();
        }
        else{
          this.$parent.$parent.modalCloseDetail();

        }
    },

    formatPrice(value) {
      let val = (value / 1).toFixed().replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    // direct ke edit form
    editDriver(id) {
      //pindah ke page edit, id juga ikut dikirim melalui route
      this.$router.push({
        name: "Edit Driver",
        params: { fms_driver: id, id },
      });
    },

    // direct ke list view table
    backtoList() {
      //kembali ke list
      this.$router.replace({ name: "List Driver" });
    },

    // previewImgObject() {
    //   const $viewer = viewerApi({
    //     options: {
    //       toolbar: true,
    //       url: 'data-source',
    //       initialViewIndex: 2,
    //     },
    //     images: this.driver_license_photo,
    //   })
    //   console.log($viewer)
    // },

    updateStatusConfirmation(status, status_text) {
      Swal.fire({
        title: "Are you sure want to change the status to " + status_text + "?",
        text: "The data will Saved!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, change it!",
        cancelButtonText: "No, cancel!",
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.updateStatus(status);
        }
      });
    },

    async updateStatus(status) {
      const data = {
        type: "fms_drivers",
        id: this.driver.id,
        status: status,
      };

      //console.log(data)
      try {
        //kirim data keserver
        await this.$store.dispatch("fms_driver/update", data);
        //panggil alert succes
        await this.$store.dispatch(
          "alerts/success",
          "Status Successfully update."
        );
        //jalankan fungsi kembali kelist
        this.getDriverData();
      } catch (e) {
        //panggil alert error
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong"
        );
      }
    },

    // validasi delete data
    deleteConfirmation(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You wont be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.deleteDriver(id);
        }
      });
    },

    // fungsi delete data
    async deleteDriver(id) {
      try {
        //kirim data ke server
        await this.$store.dispatch("fms_driver/destroy", id);
        //panggil alert succes
        await this.$store.dispatch(
          "alerts/success",
          "Driver data delete successfully."
        );
        //kembali ke page list
        this.$router.replace({ name: "List Driver" });
      } catch (e) {
        //panggil alert error
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong!"
        );
        this.setApiValidation(e.response.data.errors);
      }
    },
    check_object_value(array, key, value) {
      //return array.some(object => object[key] === value);
      return array.some((object) => value.includes(object[key]));
    },

    printPage() {
      window.print();
    },
  },
};
</script>
<style lang="scss" scoped>
.title-name {
  background-color: powderblue;
}
table {
  width: 100%;
  table-layout: fixed;
}
.table-kotak {
  border-collapse: collapse;
}
table.table-kotak td {
  border: 1px solid black;
  padding-left: 5px;
  padding-right: 5px;
}
table.table-kotak th {
  border: 1px solid black;
  padding-left: 5px;
  padding-right: 5px;
}
.print {
  visibility: hidden;
}

.bold-title {
  font-weight: bold;
}

.pointer {
  cursor: pointer;
}

.photo_list {
  max-width: 20%;
  height: 100px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.photo {
  /* height:400px; width:350px; */
  max-width: auto;
  height: 400px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
@media print {
  .print {
    visibility: visible;
  }
  .noprint {
    display: none;
  }
}

.md-card-header {
  background-color: transparent !important;
}

.nodata {
  /* text-decoration:underline; */
  text-align: center;
  color: #aaa;
}

.z-index {
  z-index: 510 !important;
}

.md-content1 {
  max-width: 800px;
  max-height: 500px;
  overflow: auto;
}

.padding {
  padding: 0 !important;
  margin: 0 !important;
}

.justify-content {
  justify-content: left !important;
}

.color {
  background-color: #1976d2 !important;
}
</style>
